import {
    CREATE_VEHICLE_UPAD,
    DELETE_VEHICLE_UPAD,
    GET_VEHICLE_UPAD,
    VEHICLE_UPAD_REQUEST,
    VEHICLE_UPAD_REQUEST_FAILURE,
    UPDATE_VEHICLE_UPAD
  } from "../types/vehicle-upad-types";
  
  const initialState = {
    vehicleUpad: [],
    loading: false,
    error: null,
  };

  const vehicleUpadReducer = (state = initialState, action) => {
    switch (action.type) {
      case VEHICLE_UPAD_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_VEHICLE_UPAD: {
        return {
          ...state,
          vehicleUpad: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_VEHICLE_UPAD:
        return {
          ...state,
          vehicleUpad: [action.payload, ...state.vehicleUpad],
          loading: false,
          error: null
        };
      case UPDATE_VEHICLE_UPAD:
        const vehicleUpadData = state.vehicleUpad.slice(0);
        console.log('before>>', vehicleUpadData);
        const uIndex = vehicleUpadData.findIndex((data) => data.id === action.payload.id);
        console.log('uIndex>>', uIndex);
        vehicleUpadData.splice(uIndex, 1, { ...action.payload.data });
        console.log('after>>', vehicleUpadData.splice(uIndex, 1, { ...action.payload.data }));
        
        return {
          ...state,
          vehicleUpad: [ ...vehicleUpadData ],
          loading: false,
          error: null
        };
      case DELETE_VEHICLE_UPAD:
        const vehicleUpad = state.vehicleUpad?.slice(0);
        const index = vehicleUpad.findIndex((data) => data.id === action.id);
        if (index > -1) {
          vehicleUpad.splice(index, 1);
        }
        return {
          ...state,
          vehicleUpad: [...vehicleUpad],
          loading: false,
          error: null
        }
      case VEHICLE_UPAD_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };

  export default vehicleUpadReducer;
  